import { type Mesh, Vector3 } from '@seddi/three';
import { BufferAttributeAccessor3 } from './bufferAttributeAccessor';

export const computeWorldPosition = (() => {
  const p = new Vector3();

  return (mesh: Mesh): Float32Array => {
    const attr = mesh.geometry.getAttribute('position');
    const accessor = new BufferAttributeAccessor3(attr);
    const count = accessor.count;
    const matrixWorld = mesh.matrixWorld;
    const target = new Float32Array(3 * count);

    for (let i = 0; i < count; ++i) {
      accessor.at(i, p).applyMatrix4(matrixWorld);
      target[i * 3] = p.x;
      target[i * 3 + 1] = p.y;
      target[i * 3 + 2] = p.z;
    }

    return target;
  };
})();
